import { render, staticRenderFns } from "./Time-Slotes.vue?vue&type=template&id=6c7080c9"
import script from "./Time-Slotes.vue?vue&type=script&lang=js"
export * from "./Time-Slotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports